var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// src/pages/CallFlows/ManageCallFlows.tsx
import { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { Box, Button, Stack, Typography, Dropdown, MenuButton, Menu, MenuItem, IconButton, Skeleton, Chip, } from "@mui/joy";
import MoreVert from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useColorScheme } from "@mui/joy/styles";
import { useNavigate } from "react-router-dom";
import { useCallFlows } from "../../data/hooks/useCallFlows";
var ActionDropdown = function (_a) {
    var flowId = _a.flowId, onDelete = _a.onDelete, onEdit = _a.onEdit;
    return (_jsxs(Dropdown, { children: [_jsx(MenuButton, __assign({ slots: { root: IconButton }, slotProps: { root: { variant: "plain", color: "neutral" } } }, { children: _jsx(MoreVert, {}) })), _jsxs(Menu, __assign({ placement: "bottom-end", size: "sm" }, { children: [_jsxs(MenuItem, __assign({ onClick: function () { return onEdit(flowId); } }, { children: [_jsx(EditIcon, { sx: { mr: 1 } }), "Edit"] })), _jsxs(MenuItem, __assign({ onClick: function () { return onDelete(flowId); }, variant: "soft", color: "danger" }, { children: [_jsx(DeleteIcon, { sx: { mr: 1 } }), "Delete"] }))] }))] }));
};
export var ManageCallFlows = function () {
    var mode = useColorScheme().mode;
    var _a = useState(mode === "dark"), darkMode = _a[0], setDarkMode = _a[1];
    var _b = useCallFlows(), callFlows = _b.callFlows, getAllCallFlows = _b.getAllCallFlows, deleteCallFlow = _b.deleteCallFlow;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var navigate = useNavigate();
    useEffect(function () {
        setDarkMode(mode === "dark");
    }, [mode]);
    useEffect(function () {
        setLoading(true);
        getAllCallFlows().finally(function () { return setLoading(false); });
    }, []);
    var handleDelete = function (flowId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm("Delete call flow with id '".concat(flowId, "'?"))) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteCallFlow(flowId)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleEdit = function (flowId) {
        navigate("/call-flows/edit/".concat(flowId));
    };
    var handleCreateNew = function () {
        navigate("/call-flows/create");
    };
    var defaultColDef = useMemo(function () {
        return {
            filter: true,
            editable: false,
            resizable: true,
        };
    }, []);
    var columnDefs = [
        {
            headerName: "Name",
            field: "name",
            flex: 2,
        },
        {
            headerName: "Assigned Phone Numbers",
            field: "assignedPhoneNumbers",
            flex: 3,
            cellStyle: { display: "flex", alignItems: "center" },
            cellRenderer: function (params) {
                return params.value && params.value.length > 0 ? (_jsx(Box, __assign({ sx: { display: "flex", alignItems: "center", height: "100%" } }, { children: _jsx(Stack, __assign({ direction: "row", spacing: 1, sx: {
                            flexWrap: "wrap",
                            alignItems: "center",
                            height: "100%",
                        } }, { children: params.value.map(function (phone) { return (_jsx(Chip, __assign({ variant: "soft", color: "primary", size: "md" }, { children: phone.friendlyName }), phone.id)); }) })) }))) : (_jsx(_Fragment, { children: "No assigned numbers" }));
            },
        },
        {
            headerName: "Created At",
            field: "createdAt",
            flex: 2,
            valueFormatter: function (params) { return new Date(params.value).toLocaleString(); },
        },
        {
            headerName: "Actions",
            field: "actions",
            sortable: false,
            filter: false,
            width: 100,
            maxWidth: 100,
            cellRenderer: function (params) { return (_jsx(Box, __assign({ sx: {
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    justifyContent: "center",
                } }, { children: _jsx(ActionDropdown, { flowId: params.data.id, onDelete: handleDelete, onEdit: handleEdit }) }))); },
        },
    ];
    return (_jsxs(Stack, __assign({ direction: "column", spacing: 2, sx: { width: "100%", height: "100%" } }, { children: [_jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center", sx: { px: 2 } }, { children: [_jsx(Typography, __assign({ sx: { mt: 2 }, level: "h2", component: "h1" }, { children: "Manage Call Flows" })), _jsx(Button, __assign({ startDecorator: _jsx(AddIcon, {}), onClick: handleCreateNew, variant: "solid", color: "primary", sx: { mt: "6" } }, { children: "Create New Flow" }))] })), _jsx(Box, __assign({ sx: { mt: 1, px: 2, width: "100%", height: "100%" } }, { children: loading ? (_jsx(Box, __assign({ sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: 2,
                        padding: 2,
                    } }, { children: __spreadArray([], Array(15), true).map(function (_, index) { return (_jsx(Box, __assign({ sx: { display: "flex", flexDirection: "column", gap: 1 } }, { children: _jsx(Skeleton, { variant: "rectangular", height: 30 }) }), index)); }) }))) : (_jsx(Box, __assign({ sx: { width: "100%", height: "100%" }, className: !darkMode ? "ag-theme-quartz" : "ag-theme-quartz-dark" }, { children: _jsx(AgGridReact, { rowData: callFlows, columnDefs: columnDefs, pagination: true, defaultColDef: defaultColDef, enableCellTextSelection: true }) }))) }))] })));
};
